import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold text-teal-800 mb-6">Terms and Conditions</h1>

      <p className="mb-4">
        These Terms and Conditions ("Terms") govern your access to and use of the IBAN Analyzer API ("we", "us", or "our").
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">1. Acceptance of Terms</h2>
      <p className="mb-4">
        By accessing or using the IBAN Analyzer API, you agree to be bound by these Terms. If you do not agree,
        you may not use the service.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">2. Services</h2>
      <p className="mb-4">
        IBAN Analyzer API provides programmatic access to IBAN validation, bank data retrieval, and other related services.
        You must register to access the API and comply with your selected plan's usage limits.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">3. Payments and Subscriptions</h2>
      <p className="mb-4">
        Paid plans are billed through our authorized reseller. All prices include VAT where applicable.
        Subscriptions renew automatically unless canceled.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">4. Fair Use and Restrictions</h2>
      <p className="mb-4">
        You must not use the IBAN Analyzer API for any fraudulent, illegal, or unauthorized purposes. Any attempt to use this service
        to facilitate fraud or violate laws will result in immediate termination of access and may be reported to the relevant authorities.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">5. Information Disclaimer</h2>
      <p className="mb-4">
        All information provided by the IBAN Analyzer API is for informational purposes only and should not be considered legal,
        financial, or professional advice. Any use of this information for making payments or financial decisions is at your own risk.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">6. Termination</h2>
      <p className="mb-4">
        You may cancel your subscription at any time. We reserve the right to terminate or suspend access for
        violations of these Terms.
      </p>
      
      <h2 className="text-xl font-semibold mt-8 mb-2">7. Refund Policy</h2>
        <p className="mb-4">
        We offer a 14-day refund policy. If you're not satisfied with your purchase, you may request a refund within 14 days of the transaction date.
        To initiate a refund, please contact our support team at{' '}
        <a href="mailto:support@iban-analyzer.com" className="text-teal-600 underline">
            support@iban-analyzer.com
        </a>.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">8. Changes</h2>
      <p className="mb-4">
        We may update these Terms from time to time. Continued use of the API means you accept the updated terms.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">8. Contact</h2>
      <p className="mb-4">
        If you have any questions, please contact us at:{' '}
        <a href="mailto:support@iban-analyzer.com" className="text-teal-600 underline">
          support@iban-analyzer.com
        </a>
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Last updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
};

export default TermsAndConditions;